import "zod/compile";
import { oc } from "@orpc/contract";
import { z } from "zod";
import {
  surplusDefinitionSchema,
  surplusExpectedStateSchema,
  surplusProfileSchema,
  surplusProviderSchema,
} from "@erp/shared-types";
import { StockSurplusSchema } from "./stock-surplus";
export const SurplusSettingsResponseSchema = z.object({
  profile: surplusProfileSchema.nullable(),
  activeDefinition: surplusDefinitionSchema,
  source: z.enum(["saved", "default"]),
  providers: z.array(surplusProviderSchema),
  warnings: z.array(z.string()),
});
export const surplusSettingsContracts = {
  get: oc.output(SurplusSettingsResponseSchema).route({
    method: "GET",
    summary: "Read surplus diagnostic composition",
    description:
      "Read saved settings or the implicit v1-equivalent default without writing. Source failures do not activate defaults.",
  }),
  save: oc
    .input(
      z.strictObject({
        draft: surplusDefinitionSchema,
        expected: surplusExpectedStateSchema,
      }),
    )
    .output(SurplusSettingsResponseSchema)
    .route({
      method: "POST",
      summary: "Save surplus and minimum composition atomically",
      description:
        "Save using exact expected profile identity under a configuration lock. Affects subsequent diagnostic reads and exports only.",
    }),
  preview: oc
    .input(
      z.strictObject({
        draft: surplusDefinitionSchema,
        productV3Key: z.string().min(1),
        warehouseId: z.uuid(),
        expectedFingerprint: z.string().nullable(),
      }),
    )
    .output(
      z.object({
        saved: StockSurplusSchema,
        draft: StockSurplusSchema,
        difference: z.number().nullable(),
        evaluatedAt: z.string(),
        changedComponentIds: z.array(z.string()),
      }),
    )
    .route({
      method: "POST",
      summary: "Compare saved and draft surplus using the same facts",
      description:
        "Preview a readable product and location with pinned settings and a shared fact bundle. Does not save or activate settings.",
    }),
} as const;
